import { render, staticRenderFns } from "./DaiR_Result.vue?vue&type=template&id=be2e641a"
import script from "./DaiR_Result.vue?vue&type=script&lang=js"
export * from "./DaiR_Result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports